import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Breadcrumbs from '../../../../../components/UI/Breadcrumbs';
import SelectItem from '../../../../../components/UI/SelectItem';
import { translate, isNullOrEmpty } from '../../../../../utils/util';
import * as actionsLinePicking from '../../../../../actions/linePickingAction';
import M from 'materialize-css/dist/js/materialize';
import { ENUMS } from '../../../../../utils/constants';

const SmallPartsFilterByUser = (props) => {
    const [user, setUser] = useState();

    useEffect(() => {
        props.resetFilter()
        // eslint-disable-next-line
    }, []);

    const applyFilter = () => {
        if (!isNullOrEmpty(user.replace("fiatauto\\", ""))) {
            props.filter.lockedBy = user;
            props.filter.orderType = ENUMS.eOrderType.LinePicking.value;
            props.filter.allOrders = true;
            props.setFilterOrder(props.filter);
            // Redirect para tela de Orders
            props.history.push({
                pathname: '../orders',
            });
        }
    };

    const subtitlesPickingFilterByUser = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('line-picking:linepicking.filterByUser') }];
    }

    const onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            setUser(value);
            M.updateTextFields();
        }
    };

    const onChangeSelectItem = (value) => {
        setUser(value);
        M.updateTextFields();
    };

    return (
        <div>
            <Breadcrumbs id="pickingFilterByUser" subtitles={subtitlesPickingFilterByUser()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="input-field no-padding col s12">
                        <SelectItem
                            required
                            id="username"
                            name="model.userName"
                            label={translate('expedition:picking.new-userName')}
                            onChange={(event) => onChangeSelectItem(event)}
                            onChangeData={onChangeData}
                            data={props.usersFromElog ? props.usersFromElog.map(item => {
                                return {
                                    id: item.id,
                                    text: item.user
                                }
                            }) : []}
                        />
                    </div>
                </div>
                <div className="row" style={{ marginBottom: '0px' }}>
                    <button
                        type="button"
                        className="col s12 m3
                        btn
                        btn-principal
                        waves-effect
                        waves-light"
                        onClick={() => applyFilter()}
                    >
                        {translate('apply', 'general')}
                    </button>
                </div>
            </div>
        </div>
    );
};

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(actionsLinePicking.setFilter(filter));
        },
        resetFilter: () => {
            dispatch(actionsLinePicking.resetFilter());
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmallPartsFilterByUser)));
